import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import iptrackerdetails from '../../../iptrackerdetails'

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'userrestrictionlist',
    components: {
        Paginate,
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
            isLoading: false,
            pageno: 0,
            pagecount: 0,
            threshold:"",
            frequency:"per day",
            editthreshold:"",
            editfrequency:"per day",
            resultCount: '',
            incrementResultCount: '',
            localuserid:'',
            localusermailid:'',
            editid:null,
            erroreditthreshold:'',
            listStatusData:[],
            allvisiblestatus:[],
            hublist:[],
            hubid:null,
            utype:null,
            userlist:[],
            userid:null,
            eventvaluelist:[],
            eventvalue:null,
            editeventvalue:"",
            edituserid:"",
            editfirstname:"",
            editemail:"",
            editeventtype:"",
            iptrackData:'',
            alluserdata:[],
            onlyadmin: false,
            localroleid: '',
        }
    },
    created: function() {

    },
    async mounted() {
      this.$validator.reset();
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);



        this.iptrackData = userdetail
        let iptrck= await iptrackerdetails.checkUserIPV2(this.iptrackData,'User Restricition List',this.$route.path);
        if(iptrck){
          this.$router.push('/');
        }

        this.localroleid = userdetail.roleid;
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.pagecount =1;
        this.getsuserrestrictionData();
        this.getallvisiblestatusData();
        this.getallhublist();

    },
    methods: {
      getallhublist(){
        this.hubid=null;
        this.userlist=[];
        this.userid=null;
        var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');    
          this.input = ({            
            });          
          axios({
            method: "GET",
            url: apiUrl.api_url + "external/gethubservicecenterlist",
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }    
          }).then(
            result => {
              var data = [];
              result.data.hubs.data.forEach(function (hubData) {
                data.push({
                  id:hubData.HubID,
                  label:hubData.HubName
                });
              });
              this.hublist = data;
            },
            error => {
              console.error(error);
            }
          );

      },
      getusers(){
        this.userid=null;
        this.userlist=[];
        var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');    
          this.input = ({  
              'hubid':this.hubid.id,
              'utype':this.utype          
            }); 
            let utypeid=  this.utype;       
          axios({
            method: "POST",
            url: apiUrl.api_url + "getutypehubuserlist",
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }    
          }).then(response => {
          if (response.data.code == 200) {              
            var data = [];
            let udata=[];
            response.data.data.forEach(function (userdata) {
                let usernamedata=(utypeid=="2" ? userdata.email : userdata.OldDeliveryUserOrUserId) 
                data.push({
                  id:userdata.userid,
                  label:userdata.FirstName +"("+usernamedata+")"
                });
                udata.push({
                  userid:userdata.userid,
                  email:userdata.email,
                  OldDeliveryUserOrUserId:userdata.OldDeliveryUserOrUserId,
                  roleid : userdata.roleid
                })
              });
              this.alluserdata=udata;
              this.userlist = data;
          }else {
              this.$alertify.error(response.data.message);              
          }
          })
          .catch(httpException => {
          console.error("exception is:::::::::", httpException);
          });
      },
      changeusertype(){
        this.userid=null;
        this.userlist=[];
        this.threshold='';
        this.frequency='per day';
        this.localusermailid
        this.hubid=null;
      },
        getallvisiblestatusData(){
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
    
          this.input = ({
            
            });
          this.isLoading = true;
          axios({
            method: "POST",
            url: apiUrl.api_url + "getallvisiblestatusrestictions ",
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }    
          }).then(response => {
            if (response.data.code == 200) {              
              var data = [];
              response.data.data.forEach(function (statusdata) {
                  data.push({
                    id:statusdata._id,
                    label:statusdata.name
                  });
                });
                this.eventvaluelist = data;
            }else {
                this.$alertify.error(response.data.message);              
            }
            })
            .catch(httpException => {
            console.error("exception is:::::::::", httpException);
            });
        },
        getsuserrestrictionData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
      
            this.input = ({
              offset: this.pageno,
              limit: 10
              });
            this.isLoading = true;
            axios({
              method: "POST",
              url: apiUrl.api_url + "listuserrestriction ",
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
      
            }).then(
              result => {
                this.listStatusData = result.data.data;
                this.isLoading = false;
                let totalRows = result.data.count;
                this.resultCount = result.data.count;
                this.incrementResultCount = result.data.count + 1;
                this.weightage=this.incrementResultCount;
                if (totalRows < 10) {
                  this.pagecount = 1;
                } else {
                  this.pagecount = Math.ceil(totalRows / 10);
                }
              },
              error => {
                console.error(error);
              }
            );
          },
        Updatestatus(data){
            this.erroreditthreshold="";
            this.editid=data._id;
            this.editeventtype=data.eventtype;
            this.editeventvalue=data.eventvalue;
            this.edituserid=data.userid;
            this.editfirstname=data.FirstName;
            this.editthreshold=data.threshold;
            this.editfrequency=data.frequency;
            this.editemail=data.email;
            if(data.utype == 2){
              this.onlyadmin = true;
            } else {
              this.onlyadmin = false;
            }
            this.$refs['editpopup'].show();
        },
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getsuserrestrictionData()
        },
        addpopupopen(){
          this.$refs['addpopup'].show(); 
          this.resetform();  
          this.$validator.reset();          
        },
        addpopupclose(){
            this.$refs['addpopup'].hide();  
            this.$validator.reset();
            this.resetform();          
        },
        editpopupclose(){
          this.editid="";
          this.editstatusname="";
          this.editthreshold="";
          this.editfrequency="per day";
          this.editisvisble="";
          this.erroreditthreshold="";
            this.$refs['editpopup'].hide();
        },
        onSubmit: function(event) {
              this.$validator.validate('eventvalue').then((evalue)=>{ 
               
            })
              this.$validator.validate('utype').then((utypev)=>{ 
                
            })  
              this.$validator.validate('hubid').then((hubidv)=>{ 
               
            })
              this.$validator.validate('userid').then((useridv)=>{ 
               
              }) 
              this.$validator.validate('threshold').then((thresholdv)=>{ 
                 
              }) 
              this.$validator.validate('frequency').then((frequencyv)=>{ 
               
              })
              

            //this.$validator.validateAll().then((result) => {
              //if(result){
             let useremail= "";
              var user = this.alluserdata.find(item => item.userid === this.userid.id);
              if(user)
              {
                if(this.utype == 2){
                  useremail = user.email;
                }else{
                  useremail = "";
                }
              }            
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                let eventtype="shipmentstatus";

                let findobj =  this.alluserdata.find(obj => obj.userid === this.userid.id)
               let roleid = null;
                if(findobj){
                  roleid = findobj.roleid
                }

                let reqpayload = ({
                  userid: (this.userid?this.userid.id:null),
                  eventtype:eventtype,
                  eventvalue:this.eventvalue,
                  threshold: this.threshold,
                  frequency: this.frequency,
                  createdby: this.localusermailid,
                  utype: this.utype,
                  useremail: useremail,
                  roleid:  roleid
              })                       
                axios({
                    method: "POST",
                    url: apiUrl.api_url + "insertuserrestriction",
                    'data': reqpayload,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                    })
                    .then(response => {
                      console.log(response);
                    if (response.data.code == 200) {
                        this.$alertify.success(response.data.message);
                        this.$refs['addpopup'].hide();                         
                        this.resetform();
                    }else if (response.data.code == 204) {
                        this.$alertify.error(response.data.message);                        
                    }else {
                        this.$alertify.error(response.data.message);
                        this.$refs['addpopup'].hide(); 
                        this.resetform();
                    }
                    })
                    .catch(httpException => {
                    console.error("exception is:::::::::", httpException);
                    });


              //}
            // }).catch(() => {
            //   console.log('errors exist', this.errors)
            // });
          },

         async onUpdateSubmit(){
                    if(this.editthreshold==""){
                        this.erroreditthreshold="Threshold Field is required";
                        return false;
                    }
                    if(this.editthreshold<0){
                      this.erroreditthreshold="The threshold field must be 0 or more.";
                      return false;
                  }
                    this.erroreditfrequency="per day";
                                    
                  var userToken = window.localStorage.getItem('userToken')
                  var myStr = userToken.replace(/"/g, '');
                  let payloaduser = {
                    UserIds : [this.edituserid]
                  }

                  let response= await  axios({
                    method: "POST",
                    url: apiUrl.api_url + "external/getUserDetails",
                    'data': payloaduser,
                    headers: {
                        'Authorization': apiUrl.secretkey
                    }
                    });
                    let userroleid = "";

                    if (response.data.code == 200) {
                      if(response.data.data.length > 0){
                        userroleid = response.data.data[0].roleid
                      }
                    }

                  let reqpayload = ({
                      id:this.editid,
                      threshold: this.editthreshold,
                      modifiedby: this.localusermailid,
                      roleid:  userroleid
                  })
                                       
                  axios({
                      method: "POST",
                      url: apiUrl.api_url + "updateuserrestriction",
                      'data': reqpayload,
                      headers: {
                          'Authorization': 'Bearer ' + myStr
                      }
                      })
                      .then(response => {
                      if (response.data.code == 200) {
                          this.$alertify.success(response.data.message);
                          this.$refs['editpopup'].hide(); 
                          this.resetform();
                          this.getsuserrestrictionData();
                          //window.location.reload();
                      }else if (response.data.code == 209) {
                          this.$alertify.error(response.data.message);                        
                      }else {
                          this.$alertify.error(response.data.message);
                          this.$refs['editpopup'].hide();  
                          this.getsuserrestrictionData();
                          this.resetform();
                          //window.location.reload();
                      }
                     // iptrackerdetails.checkUserIP(this.iptrackData,'Add Status',this.$route.path,reqpayload,response.data);
  
                      })
                      .catch(httpException => {
                      console.error("exception is:::::::::", httpException);
                      });
          },
          isIntegerOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode < 48 || charCode > 57 || this.threshold.length>9 || this.editthreshold.length>9) {
              evt.preventDefault();
            }
            else {
              return true;
            }
          },
          resetform() {
            this.eventvalue = null;
            this.threshold = "";
            this.frequency = "per day";
            this.utype=null;
            this.hubid=null;
            this.userid=null;
            this.userlist=[];
            this.editid="";
            this.editstatusname="";
            this.editthreshold="";
            this.editfrequency="per day";
            this.editisvisble="";
            this.getsuserrestrictionData();
          },
    }
}




// WEBPACK FOOTER //
// ./src/views/components/userrestrictionlist/userrestrictionlist.component.js